<svelte:window bind:innerWidth={width} bind:innerHeight={height} />

<div in:AnimIN out:AnimOUT>
    {#if width > height}
        <HostNewGameButton on:click={host} />
    {:else}
        <Join {socket} on:close={closeJoinRoom} />
    {/if}
</div>

<style>
div{
    width: 75%;
    flex-direction: column;
    text-align: center;
}
</style>

<script>
import { AnimIN, AnimOUT } from "../code/anim.js"

import HostNewGameButton from "../components/buttons/HostNewGame.svelte"
import Join from "../layout/join/Join.svelte"

export let socket

let showJoinRoom = false
let width = 0
let height = 0

const host = () => socket.emit('host')
const closeJoinRoom = () => showJoinRoom = false
</script>